import $ from 'jquery';
import * as UI from './features/ui';
import * as Forms from './features/forms';
import * as Lists from './features/lists';
import * as Tables from './features/table';
import mapboxgl from 'mapbox-gl';
import { initMapGL } from './features/mapsGL';
import { initMapLeaflet } from './features/mapsL';

// A tiny chooser that lets you force either path via query toggles:
//   ?forceLeaflet=1 → Leaflet no matter what
//   ?forceGL=1      → GL no matter what (if supported)
function shouldUseLeaflet() {
  const q = window.location.search;
  if (/[?&]forceLeaflet=1(&|$)/.test(q)) return true;
  if (/[?&]forceGL=1(&|$)/.test(q)) return false;
  try {
    return !mapboxgl.supported();
  } catch (e) {
    return true;
  }
}

export function loadEvents() {
  // --- UI site-wide (tooltips, anchors/jumpto, nav/search, header offset, etc.)
  UI.init(); // preserves your improved anchor offset + sessionStorage hash flow. 

  // --- Forms (FormAssembly behaviors + Ajax submit)
  Forms.init(); // same logic as your v11 file. 

  // --- Lists (organizations/vendors toggles, load-more, vendor directory “bandicoot” pieces)
  Lists.init({
    onVendorToggle: () => { try { window._ILSFA_setMapSize && window._ILSFA_setMapSize(); } catch (e) {} },
    onOrgToggle: (latLng, title) => { try { window._ILSFA_flyTo && window._ILSFA_flyTo(latLng, title); } catch (e) {} },
  }); // preserves your existing click->toggle->Waypoints refresh flow. 

  // --- Tables (tables within the main content tag)
  Tables.init();

  // --- Map (page-gated; same pages as before)
  const $map = $('#map');
  if ($map.length && (
    $('body').hasClass('job-training') ||
    $('body').hasClass('grassroots-education') ||
    $('body').hasClass('vendor-directory')
  )) {
    
    if (shouldUseLeaflet()) {
      initMapLeaflet(); // legacy path with county boundaries + labels. 
    } else {
      initMapGL(); // GL path with clusters, hover layer, GL boundaries/labels. 
    }
  }

  // Keep resize hooks aligned with old behavior (recalc UI + resize map)
  $(window).on('resize', () => {
    UI.onResize();
    try { window._ILSFA_setMapSize && window._ILSFA_setMapSize(); } catch (e) {}
  });
}
